import React from "react";
import { withStyles } from '@mui/styles';
import TableCell from '@mui/material/TableCell';
import SortLabel from "./SortLabel";

const stylesForName = {
  root: {
    color: 'blue',
  },
};
  
function StyledTableCellForNameTemp(props) {
  const { classes , children , ...rest } = props;
  return <TableCell {...rest} className={classes.root}>{children}</TableCell>;
}

export const StyledTableCellForName = withStyles(stylesForName)(StyledTableCellForNameTemp);


const stylesForStatus = {
  red: {
    color: 'red',
  },
  black: {
      color: 'black',
  },
};
  
  function StyledTableCellForStatusTemp(props) {
    const { classes , children , rowstatus, ...rest } = props;
    return <TableCell {...rest} className={rowstatus==="EXPIRED" ? classes.red : classes.black}>{children}</TableCell>;
  }
  
  export const StyledTableCellForStatus = withStyles(stylesForStatus)(StyledTableCellForStatusTemp);

  const stylesForSortLabel = {
    activeSortIcon: {
      opacity: 1,
      color: "white",
    },
    // Half visible for inactive icons
    inactiveSortIcon: {
      color: "white",
      opacity: 0.4,
    },
  };
    
  function StyledSortLabelTemp(props) {
    const { classes , children , ...rest } = props;
    return <SortLabel {...rest} classes={classes}>{children}</SortLabel>;
  }
  
  export const StyledSortLabel = withStyles(stylesForSortLabel)(StyledSortLabelTemp);